import React from 'react';
import PropTypes from 'prop-types';

CoverPlan.propTypes = {
  image: PropTypes.string
};

export function CoverPlan({ image }) {
  const styles = {
    width: '100%',
    height: '5.6rem',
    backgroundSize: 'cover',
    backgroundImage: `url(${image})`,
    backgroundColor: 'rgba(187,189,199,0.2)'
  };
  return (
    <div className="coverPlan" style={styles} />
  );
}
